import { useEffect } from 'react';
import { App as CapacitorApp } from '@capacitor/app';
import { Network } from '@capacitor/network';
import { StatusBar, Style } from '@capacitor/status-bar';
import { useNavigate } from 'react-router-dom';
import { routeForMobileLink } from '@/lib/mobileLinkRouter';
import { isNativeApp } from '@/lib/platform/runtime';

export default function NativeAppBridge() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isNativeApp()) return;
    document.documentElement.dataset.nativeApp = 'true';
    void StatusBar.setStyle({ style: Style.Dark });
    void StatusBar.setBackgroundColor({ color: '#4338ca' });

    const subscriptions = [
      CapacitorApp.addListener('appUrlOpen', ({ url }) => {
        const route = routeForMobileLink(url);
        navigate(route ?? '/');
      }),
      CapacitorApp.addListener('appStateChange', ({ isActive }) => {
        document.documentElement.dataset.appActive = String(isActive);
      }),
      Network.addListener('networkStatusChange', ({ connected }) => {
        document.documentElement.dataset.online = String(connected);
        window.dispatchEvent(new CustomEvent('skore:network', { detail: { connected } }));
      }),
    ];

    void CapacitorApp.getLaunchUrl().then((result) => {
      const route = result?.url ? routeForMobileLink(result.url) : null;
      if (route) navigate(route, { replace: true });
    });
    void Network.getStatus().then(({ connected }) => {
      document.documentElement.dataset.online = String(connected);
    });

    const captureRoute = window.sessionStorage.getItem('skore.capture-route');
    if (captureRoute && ['/upcoming', '/plan', '/settings'].includes(captureRoute)) {
      window.sessionStorage.removeItem('skore.capture-route');
      navigate(captureRoute, { replace: true });
    }

    return () => {
      subscriptions.forEach((subscription) => void subscription.then((handle) => handle.remove()));
      delete document.documentElement.dataset.nativeApp;
    };
  }, [navigate]);

  return null;
}
